import { GlobalActions, PreiseStreckeErmittelt } from '@ps20-frontend/shop-integration-redux';
import {
  App,
  convertBffZuersZoneIdtoZuersZoneEnum,
  ElementarSelbstbehalt,
} from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { convertElementarSBToElementarSelbstbehalt } from '../sagas/transformer/elementarSB.transformer';

export function elementarSelbstbehalt(
  sectionState: ElementarSelbstbehalt = null,
  action: AnyAction,
): ElementarSelbstbehalt {
  if (action.type === GlobalActions.PREISE_STRECKE_ERMITTELT && action.payload.appId === App.VHV_V2) {
    const actionPayload: PreiseStreckeErmittelt = action.payload;
    if (
      sectionState.id !==
      convertBffZuersZoneIdtoZuersZoneEnum(actionPayload.taasResponsePayload.elementarSB.id)
    ) {
      return convertElementarSBToElementarSelbstbehalt(
        actionPayload.taasResponsePayload.elementarSB,
      );
    }
  }
  return sectionState;
}
